<bit-dialog [loading]="loading()" dialogSize="large" background="alt">
  <span bitDialogTitle>{{ "importNoun" | i18n }}</span>
  <ng-container bitDialogContent>
    <tools-import
      (formLoading)="this.loading.set($event)"
      (formDisabled)="this.disabled.set($event)"
      (onSuccessfulImport)="this.onSuccessfulImport($event)"
    ></tools-import>
  </ng-container>
  <ng-container bitDialogFooter>
    <button
      [disabled]="disabled()"
      [loading]="loading()"
      form="import_form_importForm"
      bitButton
      type="submit"
      bitFormButton
      buttonType="primary"
    >
      {{ "importVerb" | i18n }}
    </button>
    <button type="button" bitButton bitFormButton buttonType="secondary" bitDialogClose>
      {{ "cancel" | i18n }}
    </button>
  </ng-container>
</bit-dialog>
